<template>
  <module-card
    v-bind="params"
    :permissions="permissions"
    :loading="loading"
    :retryFunction="retryFunction"
    :errorText="enums.responses.error"
    :segmentations="segmentations"
    @visibleChanged="$emit('visibleChanged', $event)"
  >
    <template slot="content">
      <div class="bank-loan__clean">
        <div class="bank-loan__clean__container">
          <i class="bexsicon-blueprint bank-loan__clean__icon"></i>
          <div class="bank-loan__clean__message">
            <v-btn
              class="bank-loan__clean__button"
              :to="{ name: 'bankFinancing' }"
              text
              small
              color="financial--color"
            >
              Ver todas as etapas do financiamento
            </v-btn>
          </div>
        </div>
      </div>
    </template>
    <template slot="actions">
      <v-btn
        class="slin-btn"
        :to="{ name: 'bankFinancing' }"
        :style="{ color: params.themeColor }"
      >
        <i class="bexsicon-finantial-sm" />
        Ver financiamento bancário
      </v-btn>
    </template>
  </module-card>
</template>

<script>
import ModuleCard from '@/components/layout/Card';
import {
  CONFIG,
  PROFILES,
  IFRAME,
  UNIT,
  SEGMENTATIONS,
} from '../../utils/constants';
import axios from 'axios';
import enums from '@/utils/enums';
export default {
  components: {
    ModuleCard,
  },
  computed: {
    bankLoanBaseUrl() {
      return this.$store.getters[CONFIG.GET_JUNIX_BANK_FINANCING_BASE_URL];
    },
    selectedContract() {
      return this.selectedUnit.contracts.find((contract) => contract.isValid);
    },
    canIframeInteractStyle() {
      return {
        pointerEvents: this.$store.getters[IFRAME.GET_INTERACTION]
          ? 'all'
          : 'none',
      };
    },
    segmentations() {
      const product = this.$store.getters[UNIT.GET_SELECTED_PRODUCT];

      if (product && this.bankLoanBaseUrl) {
        const constructionStage = enums.constuctionStages[product.stage];
        switch (constructionStage) {
          case 'launch':
            return [
              SEGMENTATIONS.ASSOCIATIVE__REHEARSE_STATUS,
              SEGMENTATIONS.LAUNCH__CONSTRUCTION_STAGE,
            ];
            break;
          case 'inConstruction':
            return [
              SEGMENTATIONS.ASSOCIATIVE__REHEARSE_STATUS,
              SEGMENTATIONS.IN_CONSTRUCTION__CONSTRUCTION_STAGE,
            ];
            break;
          case 'delivered':
            if (this.$store.getters[UNIT.GET_SELECTED].keyDeliveryDate) {
              return null;
            } else {
              return [
                SEGMENTATIONS.ASSOCIATIVE__REHEARSE_STATUS,
                SEGMENTATIONS.SFH__REHEARSE_STATUS,
                SEGMENTATIONS.DIRECT__REHEARSE_STATUS,
                SEGMENTATIONS.DELIVERED__CONSTRUCTION_STAGE,
              ];
            }
            break;
          default:
            return [];
        }
      } else {
        return null;
      }
    },
  },
  created() {
    const contractValidTypes = ['PCV', 'Cessão'];
    const contract = this.selectedUnit.contracts.find((contract) =>
      contractValidTypes.some((t) => t === contract.type)
    );

    if (contract !== undefined) {
      const urlBase = this.bankLoanBaseUrl;
      const client = contract.proposers.find((p) => p.isMain === true);
      this.bankFinancingUrl = `${urlBase}/${contract.id}`; //? uncomment if applicable. Ticket 35117//`${urlBase}?numeroContrato=${contract.id}`;
    }
  },
  data() {
    return {
      bankFinancingUrl: '',
      permissions: [
        PROFILES.ADMIN_PROFILE,
        PROFILES.ADMIN_BEXS_PROFILE,
        PROFILES.ADMIN_HR_PROFILE,
        PROFILES.HR_PROFILE,
      ],
    };
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    lastUpdate: String,
    stage: String,
    loading: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      required: true,
    },
    retryFunction: Function,
  },
};
</script>

<style lang="scss" scoped>
>>> .v-card__text {
  padding-top: 0;
}

.bank-loan {
  &__iframe {
    border: none;
    margin: 1% auto 0;
    padding: 0;
    height: 100%;
    width: 100% !important;
  }

  &__clean {
    height: 100%;
    background: var(--card-backdrop-color);
    border-radius: 4px;
    min-height: 6rem;
    min-width: 10rem;
    display: block;

    &__container {
      display: flex;
      padding: 20px;
    }

    &__icon {
      color: var(--grey-icon-color);
      font-size: 2.5rem;
      background: #fff;
      border-radius: 50px;
      padding: 10px;
      margin-top: auto;
      margin-bottom: auto;
      margin-left: 1.2rem;
    }

    &__message {
      margin-bottom: auto;
      margin-top: auto;
    }

    &__button {
      background-color: transparent !important;
      padding: 0.5em !important;
      font-size: 12px !important;

      >>> .v-btn__content {
        display: contents !important;
        white-space: normal !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/modules/BankLoanCard.vue